module.exports = __webpack_public_path__ + "static/media/Year-2398-background.36f39e98.jpg";